import { defineStore } from "pinia";
import { ref } from "vue";
import {
  queryCartList,
  addCart,
  deleteCart,
  clearCart,
} from "@/apis/cart";

export const useCartStore = defineStore(
  "cart",
  () => {
    // state
    const cartItems = ref([]);
    const statusCount = ref(0); // 选中商品数量
    const totalPrices = ref(0); // 选中商品总价
    const totalNum = ref(0); // 购物车总数量
    // actions
    // 通过api获取购物车列表
    const getCartList = async () => {
      try {
        const res = await queryCartList();
        if (res.code === 200) {
          cartItems.value = res.data.cartList;
          statusCount.value = res.data.totalCount;
          totalPrices.value = res.data.totalAmount;
          totalNum.value = res.data.cartList.length
          cartItems.value.every(item => item.selected = false)
        }
      } catch (error) { }
    };
    // 清空购物车
    const clearCartList = async () => {
      try {
        const res = await clearCart();
        if (res.code === 200) {
          cartItems.value = [];
        }
      } catch (error) { }
    };
    // 增加购物车商品
    /**
     *  skuId: 商品id,
     *  spuId: 商品spuId,
     *  count: 商品数量,
     */
    const addCartItemAction = async (item) => {
      return new Promise(async (resolve, reject) => {
        try {
          const params = {
            skuId: item.id,
            spuId: item.spuId,
            count: item.count,
          };
          const res = await addCart(params);
          if (res.code === 200) {
            const index = cartItems.value.findIndex(
              (cartItem) => cartItem.id === item.id
            );
            if (index === -1) {
              cartItems.value.push(item);
            } else {
              cartItems.value[index].count += 1;
            }
            console.log(123)
            resolve("添加购物车成功");
          } else {
            reject(res.message);
          }
        } catch (error) {
          reject(error);
        }
      });
    };
    // 减少购物车商品
    const removeCartItemAction = async (item) => {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await deleteCart(item.id);
          if (res.code === 200) {
            const index = cartItems.value.findIndex(
              (cartItem) => cartItem.id === item.id
            );
            if (index !== -1) {
              if (cartItems.value[index].count === 1) {
                cartItems.value.splice(index, 1);
              } else {
                cartItems.value[index].count -= 1;
              }
            }
            resolve(res.message)
          } else {
            reject(res.message)
          }
        } catch (error) {
          reject(error.message)
        }
      })
    };
    // getters
    const totalCount = () => {
      let count = 0;
      cartItems.value.forEach((item) => {
        count += item.count;
      });
      return count;
    };
    const totalPrice = () => {
      let price = 0;
      cartItems.value.forEach((item) => {
        price += item.price * item.count;
      });
      return price.toFixed(2);
    };
    return {
      cartItems,
      getCartList,
      clearCartList,
      addCartItemAction,
      removeCartItemAction,
      totalCount,
      totalPrice,
      statusCount,
      totalPrices,
      totalNum,
    };
  },
  {
    persist: true,
  }
);
